module.exports = __webpack_public_path__ + "img/RecordRevisions.8e2ae8dd.png";